import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';

export default function Header() {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isMenuActive, setIsMenuActive] = useState(false);

    useEffect(() => {
        document.documentElement.lang = i18n.language;
        document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    }, [i18n.language]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
        setIsOpen(false);
    };

    const closeMenu = () => {
        setIsMenuActive(false);
    };


    return (
        <header id="header" className="py-[10px] shadow-[0px_0px_10px_#00000021] relative z-10 transition-all duration-300 flex flex-col">
            <div className="container py-[10px] flex items-center justify-between">
                <Link to={"/"}>
                    <img className="w-[115px]" src={require("../../assets/logo/logo.svg").default} alt="Logo" />
                </Link>
                <nav className="d-none">
                    <ul className="flex items-center gap-[10px]">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Home")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("About us")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/brands"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Brands")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/collections"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Collections")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Contact us")}
                            </NavLink>
                        </li>
                    </ul>
                </nav>
                <div className="flex items-center gap-[10px]">
                    <div className="relative">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="flex items-center gap-2 p-2 text-[#666666] font-bold rounded-md capitalize"
                        >
                            <img className="w-[35px] h-[35px]" src={require("../../assets/icons/language.svg").default} alt="Language" />
                        </button>
                        {isOpen && (
                            <div className="rr absolute right-100 right-0 mt-2 w-40 bg-white shadow-lg rounded-md">
                                <div className="py-1">
                                    <button
                                        onClick={() => changeLanguage("en")}
                                        className="w-full flex items-center gap-[5px] text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-t-md"
                                    >
                                        <img className="w-[25px] h-[25px]" src={require("../../assets/icons/en.svg").default} alt="Language" />
                                        <div>English</div>
                                    </button>
                                    <button
                                        onClick={() => changeLanguage("ar")}
                                        className="w-full flex items-center gap-[5px] text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-b-md"
                                    >
                                        <img className="w-[25px] h-[25px]" src={require("../../assets/icons/ar.svg").default} alt="Language" />
                                        <div>العربية</div>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <button className={`menu ${isMenuActive ? "active" : ""}`} onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>
            {isMenuActive && (
                <nav className="top-[122px] flex flex-col gap-[20px]">
                    <ul className="flex flex-col gap-4">
                        <li>
                            <NavLink
                                to="/"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Home")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/about"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("About us")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/brands"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Brands")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/collections"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Collections")}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    `px-[3px] py-2 ${isActive ? "text-[#B88831] font-bold capitalize" : "text-black"} hover:text-[#B88831] font-bold transition duration-500 capitalize`
                                }
                                onClick={closeMenu}
                            >
                                {t("Contact us")}
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            )}
        </header>
    );
}